import { useDispatch, useSelector } from 'react-redux';

import {
  setAgreementsProcess,
  clearAgreementsProcess,
  setShowAgreementsMessageProcess,
  setShowAgreementProcess,
  getAgreements,
} from 'features/agreements/redux/slice';
import { AgreementsApiResponse, UseAgreementsState } from './types';
import { AgreementsGroupState } from '.';

const useAgreements = (): UseAgreementsState => {
  const {
    agreements,
    showAgreementProductSlug,
    showAgreementProductClassUuid,
    agreementsCount,
    showAgreementsMessage,
  } = useSelector(getAgreements);
  const dispatch = useDispatch();

  const setAgreements = (response: AgreementsApiResponse) => {
    const initialAgreements: AgreementsGroupState = {};

    const agreements = response.agreements.reduce((prev, agreement) => {
      if (!!prev[agreement.productSlug]) {
        return {
          ...prev,
          [agreement.productSlug]: {
            ...prev[agreement.productSlug],
            [agreement.productClassUuid]: agreement,
          },
        };
      }

      return {
        ...prev,
        [agreement.productSlug]: {
          [agreement.productClassUuid]: agreement,
        },
      };
    }, initialAgreements);

    dispatch(setAgreementsProcess(agreements));
  };

  const clearAgreements = () => {
    dispatch(clearAgreementsProcess());
  };

  const setShowAgreementsMessage = (show: boolean) => {
    dispatch(setShowAgreementsMessageProcess(show));
  };

  const setShowAgreement = (show: [string | null, string | null]) => {
    dispatch(setShowAgreementProcess(show));
  };

  const clearShowAgreement = () => {
    dispatch(setShowAgreementProcess([null, null]));
  };

  return {
    agreements,
    agreementsCount,
    setAgreements,
    clearAgreements,
    showAgreementsMessage,
    setShowAgreementsMessage,
    showAgreementProductSlug,
    showAgreementProductClassUuid,
    setShowAgreement,
    clearShowAgreement,
  };
};

export default useAgreements;
